<template>
  <div class="error404" redesign>
    <!-- Header -->
    <div class="local-hero">
      <h1 class="local-hero-header" v-translate>Page Not Found</h1>
    </div>

    <LogoHeader :org="organizationDetails" />

    <div class="form-container error404-form">
      <h4>
        <router-link :to="{ name: 'Home' }" v-translate>
          Return Home
        </router-link>
      </h4>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import LogoHeader from '@/components/LogoHeader'
export default {
  name: 'Error404',
  components: { LogoHeader },
  data() {
    return {}
  },
  methods: {},
  computed: mapState(['organizationDetails']),
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
@import '@/styles/mixins/containers';
@import '@/styles/mixins/responsive';

.error404 {
  display: flex;
  flex-direction: column;

  .error404-form {
    @extend .constrain-tablet-and-up;

    align-items: center;
  }
}
</style>
